import React from "react";
import GenericRoutesMap from "components/Routes/GenericRoutesMap";
import { ROUTE_CONFIGS } from "config/routeConfigs";

const ArchivedMap = () => {
  const config = ROUTE_CONFIGS.archived;
  return (
    <GenericRoutesMap
      routeType="archived"
      selector={config.selector}
      loadAction={config.loadAction}
      features={config.features}
    />
  );
};

export default ArchivedMap;